<template>
  <div class="row">
    <div class="col-lg-12">
      <StatusModal :show.sync="modals.removeModal" :message="modal.remove" :title="modal.removeTitle" />
      <StatusModal :show.sync="modals.successModal" :message="`Successfully added!`" :title="modal.successTitle" />
      <div class="row">
        <div class="col-lg">
          <div class="scrollable-row">
            <div class="col-lg-4 d-flex">
              <card class="card-eprf">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  JOB DETAILS
                </p>
                <div style="height: 520px; overflow: scroll; overflow-x: hidden">
                  <p class="new-title">Job Reference No.</p>
                  <p class="subtitle">{{ jobno }}</p>

                  <!-- <p class="new-title">Arrival ETA</p>
                  <p class="subtitle">{{ arrivalETA }}</p> -->

                  <p class="new-title">Service Location</p>
                  <p class="subtitle">
                    {{ servicelocation }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Departure (ETD)
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ departureETD }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Previous Port
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ previousPort }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Next Port
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ nextPort }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Last Port & Date When Generated Waste Delivered
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ lastPortAndDate }}
                  </p>

                  <p class="new-title">Company Name</p>
                  <p class="subtitle">{{ companyName }}</p>

                  <p class="new-title">Company Address</p>
                  <p class="subtitle">{{ companyAddress }}</p>

                  <p class="new-title">Phone No. / Fax No.</p>
                  <p class="subtitle">{{ phoneNoFaxNo }}</p>

                  <p class="new-title">PIC Full Name</p>
                  <p class="subtitle">{{ picFullName }}</p>

                  <p class="new-title">PIC Phone No. / Fax No.</p>
                  <p class="subtitle">{{ picPhoneNoFaxNo }}</p>

                  <p class="new-title">PIC Email</p>
                  <p class="subtitle">{{ picEmail }}</p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Ship Name
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ shipName }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    IMO No.
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ imoNo }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Ship Type
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ shipType }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Gross Tonnage
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ grossTonnage }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Deadweight Tonnage (kg)
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ deadweightTonnage }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Owner / Operator Name
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ owneroperatorname }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Call Sign
                  </p>
                  <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                    {{ callSign }}
                  </p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Flag State
                  </p>
                  <p class="subtitle">{{ flagState }}</p>

                  <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                    Sustainable Certificates
                  </p>
                  <div v-if="landvesselflag == 'VESSEL' && shipdoc.length !== 0" v-for="(file, index) in shipdoc"
                    :key="'allship_file' + index" class="row">
                    <div class="col-lg-8">
                      {{ index + 1 }}.
                      <a :href="file.fileurl">
                        <base-button class="btn-link btn-primary">
                          {{ file.filename }}
                        </base-button>
                      </a>
                    </div>
                  </div>
                  <p v-if="landvesselflag == 'VESSEL' && shipdoc.length === 0" class="subtitle">
                    None
                  </p>
                </div>
              </card>
            </div>
            <div v-if="generate == true" class="col-lg-4 d-flex">
              <card class="card-eprf">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  OPERATION PHOTOS
                </p>
                <div style="height: 520px; overflow: auto; overflow-x: hidden">
                  <div class="row" v-for="(card, index) in pics" :key="index">
                    <div class="col-lg">
                      <card class="card-eprf-with-header">
                        <div class="header" @click="openclose(index)">
                          <div class="row">
                            <div class="col-lg">TRIP - {{ index + 1 }}</div>
                            <div class="col-lg-3 text-right" v-if="card.flag == 'buka'">
                              <i @click="openclose(index)" class="tim-icons icon-minimal-down"></i>
                            </div>
                            <div class="col-lg-3 text-right" v-if="card.flag == 'tutup'">
                              <i @click="openclose(index)" class="tim-icons icon-minimal-right"></i>
                            </div>
                          </div>
                        </div>
                        <div class="body" v-if="card.flag == 'buka'">
                          <div class="row" style="line-height: 1px">
                            <div class="col-lg">
                              <p style="
                                  text-align: left;
                                  font-size: 17px;
                                  color: #707070;
                                  font-weight: 600;
                                ">
                                Pre-operation
                              </p>
                            </div>
                          </div>

                          <div class="row" v-if="positionid != 4 && step < 5">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #aaaaaa">
                                Please upload related photo(s)
                              </p>
                            </div>
                          </div>

                          <div class="row" style="padding-bottom: 5px; padding-top: 5px">
                            <div class="col-lg-3" v-if="positionid != 4 && step < 5">
                              <label :for="index + 'pre'">
                                <img src="@/assets/img/upload.png" width="73" height="45" />
                              </label>
                              <input accept="image/*" type="file" name="..." :id="index + 'pre'" ref="pre"
                                @change="onprechange($event, index)" :multiple="false" style="display: none" />
                            </div>
                            <div class="col-lg-3" v-for="(item, index) in card.fullsideimages" :key="index"
                              style="padding-bottom: 5px">
                              <img :src="item.url" width="73" height="45" />
                              <div style="position: absolute; right: 20%; top: 0">
                                <base-button v-if="positionid != 4 && step < 5"
                                  class="btn-icon btn-cancel btn-round btn-xs" @click="
        deletefullsideimage(
          item.imageindex,
          item.imageid
        )
        "><i class="fa fa-times" aria-hidden="true"></i></base-button>
                                <br />

                                <a :href="item.url">
                                  <base-button class="btn-icon btn-primary btn-round btn-xs"><i class="fa fa-arrow-down"
                                      aria-hidden="true"></i></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                          <br />
                          <div class="row" style="line-height: 1px">
                            <div class="col-lg">
                              <p style="
                                  text-align: left;
                                  font-size: 17px;
                                  color: #707070;
                                  font-weight: 600;
                                ">
                                During Operation
                              </p>
                            </div>
                          </div>

                          <div class="row" v-if="positionid != 4 && step < 5">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #aaaaaa">
                                Please upload related photo(s)
                              </p>
                            </div>
                          </div>

                          <div class="row" style="padding-bottom: 5px; padding-top: 5px">
                            <div class="col-lg-3" v-if="positionid != 4 && step < 5">
                              <label :for="index + 'during'">
                                <img src="@/assets/img/upload.png" width="73" height="45" />
                              </label>
                              <input accept="image/*" type="file" name="..." :id="index + 'during'" ref="during"
                                @change="onduringchange($event, index)" :multiple="false" style="display: none" />
                            </div>
                            <div class="col-lg-3" v-for="(item, index) in card.insideimages" :key="index"
                              style="padding-bottom: 5px">
                              <img :src="item.url" width="73" height="45" />
                              <div style="position: absolute; right: 20%; top: 0">
                                <base-button v-if="positionid != 4 && step < 5"
                                  class="btn-icon btn-cancel btn-round btn-xs" @click="
        deleteinsideimage(
          item.imageindex,
          item.imageid
        )
        "><i class="fa fa-times" aria-hidden="true"></i></base-button>
                                <br />

                                <a :href="item.url">
                                  <base-button class="btn-icon btn-primary btn-round btn-xs"><i class="fa fa-arrow-down"
                                      aria-hidden="true"></i></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                          <br />
                          <div class="row" style="line-height: 1px">
                            <div class="col-lg">
                              <p style="
                                  text-align: left;
                                  font-size: 17px;
                                  color: #707070;
                                  font-weight: 600;
                                ">
                                Post-operation
                              </p>
                            </div>
                          </div>

                          <div class="row" v-if="positionid != 4 && step < 5">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #aaaaaa">
                                Please upload related photo(s)
                              </p>
                            </div>
                          </div>

                          <div class="row" style="padding-bottom: 5px; padding-top: 5px">
                            <div class="col-lg-3" v-if="positionid != 4 && step < 5">
                              <label :for="index + 'post'">
                                <img src="@/assets/img/upload.png" width="73" height="45" />
                              </label>
                              <input accept="image/*" type="file" name="..." :id="index + 'post'" ref="post"
                                @change="onpostchange($event, index)" :multiple="false" style="display: none" />
                            </div>
                            <div class="col-lg-3" v-for="(item, index) in card.landarmrolls" :key="index"
                              style="padding-bottom: 5px">
                              <img :src="item.url" width="73" height="45" />
                              <div style="position: absolute; right: 20%; top: 0">
                                <base-button v-if="positionid != 4 && step < 5"
                                  class="btn-icon btn-cancel btn-round btn-xs" @click="
        deletearmrollimage(
          item.imageindex,
          item.imageid
        )
        "><i class="fa fa-times" aria-hidden="true"></i></base-button>
                                <br />

                                <a :href="item.url">
                                  <base-button class="btn-icon btn-primary btn-round btn-xs"><i class="fa fa-arrow-down"
                                      aria-hidden="true"></i></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div v-if="positionid != 4 && step < 5" class="row">
                            <div class="col-lg text-left" v-if="index > 0">
                              <base-button class="btn-link btn-cancel" @click="removetrip(index)">
                                <i class="tim-icons icon-trash-simple"></i>
                              </base-button>
                            </div>
                          </div>
                        </div>
                      </card>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg text-right">
                    <base-button v-if="positionid != 4 && step < 5" class="btn-link" @click="addtrip()">
                      + Add trip</base-button>
                  </div>
                </div>
              </card>
            </div>
            <div v-if="generate == true" class="col-lg-4 d-flex">
              <card class="card-eprf">
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                      eCAF & GATE PASS
                    </p>
                  </div>
                </div>

                <div style="height: 520px; overflow: auto; overflow-x: hidden">
                  <div class="row" v-for="(card, index) in pics" :key="index" style="line-height: normal">
                    <div class="col-lg">
                      <!-- class="card"
                        border-variant="primary"
                        header="hi"
                        header-bg-variant="primary"
                        header-text-variant="white"
                        style="
                          box-shadow: 0px 0px;
                          border: none;
                          background-color: #f5f6fa;
                          
                        " -->
                      <card class="card-eprf-with-header">
                        <!-- <template> -->
                        <div class="header" @click="openclose(index)">
                          <div class="row">
                            <div class="col-lg">TRIP - {{ index + 1 }}</div>
                            <div class="col-lg-3 text-right" v-if="card.flag == 'buka'">
                              <!-- <base-button
                              class="btn-link"
                              style="color: #ffffff"
                              
                            > -->
                              <i @click="openclose(index)" class="tim-icons icon-minimal-down"></i>
                              <!-- </base-button> -->
                            </div>
                            <div class="col-lg-3 text-right" v-if="card.flag == 'tutup'">
                              <!-- <base-button
                              class="btn-link"
                              style="color: #ffffff"
                              
                            > -->
                              <i @click="openclose(index)" class="tim-icons icon-minimal-right"></i>
                              <!-- </base-button> -->
                            </div>
                          </div>
                        </div>
                        <!-- </template> -->
                        <div class="body" v-if="card.flag == 'buka'">
                          <div class="row">
                            <div class="col-lg">
                              <p style="
                                  text-align: left;
                                  font-size: 17px;
                                  color: #707070;
                                  font-weight: 600;
                                ">
                                eCAF
                              </p>
                            </div>
                          </div>
                          <div class="row" v-if="positionid != 4 && step < 5">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #aaaaaa">
                                Please upload eCAF
                              </p>
                            </div>
                          </div>

                          <div class="row" v-if="positionid == 4 || step == 5">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #aaaaaa">
                                eCAF
                              </p>
                            </div>
                          </div>

                          <div class="row" style="padding-bottom: 5px; padding-top: 5px">
                            <div class="col-lg-3" v-if="positionid != 4 && step < 5">
                              <label :for="index + 'ek'">
                                <img src="@/assets/img/upload.png" width="73" height="45" />
                              </label>
                              <input accept="image/*" type="file" name="..." :id="index + 'ek'" ref="ekaf"
                                @change="onekafchange($event, index)" :multiple="false" style="display: none" />
                            </div>
                            <div class="col-lg-3" v-for="(item, index) in card.ekafimages" :key="index"
                              style="padding-bottom: 5px">
                              <img
                                :src="item.url.match(/\.(png|jpeg|jpg)$/i) ? item.url : require('@/assets/img/No_Available_Image.png')"
                                width="73" height="45" alt="Image" />
                              <div style="position: absolute; right: 20%; top: 0">
                                <base-button v-if="positionid != 4 && step < 5"
                                  class="btn-icon btn-cancel btn-round btn-xs" @click="
        deleteekafimage(
          item.imageindex,
          item.imageid
        )
        "><i class="fa fa-times" aria-hidden="true"></i></base-button>
                                <br />

                                <a :href="item.url">
                                  <base-button class="btn-icon btn-primary btn-round btn-xs"><i class="fa fa-arrow-down"
                                      aria-hidden="true"></i></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg">
                              <p style="
                                  text-align: left;
                                  font-size: 17px;
                                  color: #707070;
                                  font-weight: 600;
                                ">
                                Gate Pass
                              </p>
                            </div>
                          </div>
                          <div class="row" style="">
                            <div class="col-lg">
                              <p style="color: #A5A5A5; font-size: 14px">Date</p>
                              <el-date-picker filterable :disabled="positionid == 4 || step === 5"
                                v-model="card.date"></el-date-picker>
                            </div>
                          </div>
                          <div class="row" style="">
                            <div class="col-lg">
                              <p style="color: #A5A5A5; font-size: 14px">
                                Tyre Type
                              </p>
                              <!-- <el-select
                                placeholder="Select Tyre Type"
                                v-model="card.tyretype"
                                filterable
                              >
                                <el-option
                                  v-for="option in tyretypes"
                                  class="select-info custom-option"
                                  :value="option.value"
                                  :label="option.label"
                                  :key="option.value"
                                ></el-option>
                              </el-select> -->
                            </div>
                          </div>
                          <div class="row" v-for="(item, index) in card.tyretypes" :key="index">
                            <div class="col-lg" style="padding-top: 1%">
                              <p style="
                                  text-align: left;
                                  font-size: 17px;
                                  color: #707070;
                                  font-weight: 600;
                                ">
                                {{index + 1}}. {{ item.type }}
                              </p>
                            </div>
                            <div class="col-lg-6 text-left">
                              <!--  -->
                              <input v-if="positionid != 4 && step < 5" type="number" v-model="item.qty"
                                :class="{ 'custom-input': true }" min="0" @change="calculateTyreTypeSums(item)" />
                              <p v-if="positionid == 4 || step == 5" class="subtitle">{{ item.qty }} </p>

                              <!-- <p
                                style="color: #EC1B23; font-size: 10px"
                                v-if="item.qtymsg != ''"
                              >
                                {{ item.qtymsg }}
                              </p> -->
                            </div>
                          </div>
                          <!-- <div class="row" style="">
                            <div class="col-lg">
                              <p style="color: #A5A5A5; font-size: 14px">
                                Quantity (Unit)
                              </p>

                              <input
                                type="number"
                                v-model="card.quantity"
                                :class="{ 'custom-input': true }"
                                step="0.01"
                              />
                            </div>
                          </div> -->
                          <div v-if="positionid != 4 && step < 5" class="row">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #aaaaaa">
                                Please upload Gate Pass
                              </p>
                            </div>
                          </div>

                          <div v-if="positionid == 4 || step == 5" class="row">
                            <div class="col-lg">
                              <p style="font-size: 14px; color: #aaaaaa">
                                Gate Pass
                              </p>
                            </div>
                          </div>

                          <div class="row">
                            <div v-if="positionid != 4 && step < 5" class="col-lg-3">
                              <label :for="index + 'gp'">
                                <img src="@/assets/img/upload.png" width="73" height="45" />
                              </label>
                              <input accept="image/*" type="file" name="..." :id="index + 'gp'" ref="gatepass"
                                @change="ongatepasschange($event, index)" :multiple="false" style="display: none" />
                            </div>
                            <div class="col-lg-3" v-for="(item, index) in card.gatepassimages" :key="index"
                              style="padding-bottom: 5px">
                              <img
                                :src="item.url.match(/\.(png|jpeg|jpg)$/i) ? item.url : require('@/assets/img/No_Available_Image.png')"
                                width="73" height="45" alt="Image" />
                              <div style="position: absolute; right: 20%; top: 0">
                                <base-button v-if="positionid != 4 && step < 5"
                                  class="btn-icon btn-cancel btn-round btn-xs" @click="
        deletegatepassimage(
          item.imageindex,
          item.imageid
        )
        "><i class="fa fa-times" aria-hidden="true"></i></base-button>
                                <br />

                                <a :href="item.url">
                                  <base-button class="btn-icon btn-primary btn-round btn-xs"><i class="fa fa-arrow-down"
                                      aria-hidden="true"></i></base-button>
                                </a>
                              </div>
                            </div>
                          </div>
                          <br />
                        </div>
                      </card>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #EC1B23; font-size: 10px" v-if="qtymsg != ''">
                      {{ qtymsg }}
                    </p>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-lg-4" v-if="generate == 'false'">
              <card style="
                  box-shadow: none;
                  padding: 0px 0px 30px 30px;
                  height: 630px;
                  background-color: white;
                ">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  PERMIT TO WORK (PTW)
                </p>
                <p class="new-title">PTW No.</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="ptwno" :class="{ 'custom-input': true }" />
                </div>
                <!-- <p class="sub-title">12089</p> -->

                <p class="new-title">Transporter</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="transporter" :class="{ 'custom-input': true }" />
                </div>

                <p class="new-title">DOE No.</p>
                <p class="subtitle">EIA TA/13</p>

                <p class="new-title">Company Address</p>
                <p class="subtitle">
                  Lot 42, Jalan Suria 5, Kajang, 43000 Selangor, Malaysia
                </p>

                <p class="new-title">Phone No. / Fax No.</p>
                <div style="padding-right: 30px">
                  <input type="text" v-model="phoneno" :class="{ 'custom-input': true }" />
                </div>
                <!-- <p class="sub-title">+60345625454</p> -->
              </card>
            </div>
            <div class="col-lg-8" v-if="generate == 'false'">
              <card class="card-eprf">
                <div class="row">
                  <div class="col-lg">
                    <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                      WASTE DETAILS
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg">
                    <!--   :cell-class-name="evenclass" -->
                    <el-table :data="wastedetails" :header-cell-style="{
        background: '#358DCC',
        border: 'transparent',
        'font-size': '14px',
        'font-weight': '400',
        color: '#FFFFFF',
      }" :cell-style="{ fontColor: '#707070' }" :row-style="tableRowClassName" style="color: #707070">
                      <el-table-column label="No." width="50" align="center">
                        <div slot-scope="scope">
                          <p style="color: #707070">{{ scope.$index + 1 }}</p>
                        </div>
                      </el-table-column>

                      <el-table-column label="Waste Type" prop="wastetype" width="160"></el-table-column>
                      <el-table-column label="Waste Qty." prop="wasteqty"></el-table-column>
                      <el-table-column label="Max Dedicated Storage Capacity" prop="maxdedicatedstoragecapacity"
                        width="170"></el-table-column>
                      <el-table-column label="Waste Amount Retained On-board" prop="wasteamountretainedonboard"
                        width="170"></el-table-column>
                      <el-table-column label="Remarks" prop="remarks"></el-table-column>
                    </el-table>
                  </div>
                </div>
              </card>
            </div>
            <!-- <div class="col-lg-4">
            <card
              style="box-shadow: none;
                padding: 0px 0px 30px 30px;
                height: 630px;
                background-color: white;
              "
            >
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                WASTE TO BE COLLECTED
              </p>
              <p class="new-title">Waste Type</p>
              <p class="subtitle">Annex I - Oily bilge water</p>
  
              <p class="new-title">Waste Quantity</p>
              <p class="subtitle">300 MT</p>
  
              <p class="new-title">Max Dedicated Storage Capacity</p>
              <p class="subtitle">500 MT</p>
  
              <p class="new-title">Amount of Waste Retained Onboard</p>
              <p class="subtitle">50 MT</p>
            </card>
          </div>
     
          <div class="col-lg-4">
            <card
              style="box-shadow: none;
                padding: 0px 0px 30px 30px;
                height: 630px;
                background-color: white;
              "
            >
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                CUSTOMER DETAILS
              </p>
              <p class="new-title">Customer Name</p>
              <p class="subtitle">Ombak Biru Holdings</p>
  
              <p class="new-title">Ship Name</p>
              <p class="subtitle">Eagle 01</p>
  
              <p class="new-title">PIC Full Name</p>
              <p class="subtitle">Amirah binti Azman</p>
  
              <p class="new-title">PIC Phone No. / Fax No.</p>
              <p class="subtitle">+60195627890</p>
  
              <p class="new-title">PIC Email</p>
              <p class="subtitle">amirah@ombakb.com.my</p>
            </card>
          </div> -->
            <div class="col-lg-4" v-if="generate == 'false'">
              <card style="
                  box-shadow: none;
                  padding: 0px 0px 30px 30px;
                  height: 630px;
                  background-color: white;
                ">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  TRANSPORTER DETAILS
                </p>
                <p class="new-title">Transporter Name</p>
                <p class="subtitle">Berjaya Waste Sdn Bhd</p>

                <p class="new-title">PIC Full Name</p>
                <p class="subtitle">Nick Chan</p>

                <p class="new-title">Phone No. / Fax No.</p>
                <p class="subtitle">+60129923290</p>

                <p class="new-title">Vehicle Registration No.</p>
                <p class="subtitle">BGK 8080</p>
              </card>
            </div>
            <div class="col-lg-4" v-if="generate == 'false'">
              <card style="
                  box-shadow: none;
                  color: #A5A5A5;
                  padding: 0px 0px 30px 30px;
                  height: 630px;
                  background-color: white;
                ">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  CHECKLIST
                </p>
                <p class="new-title">Facility Type</p>
                <input type="checkbox" class="rounded-checkbox" id="checkbox" v-model="checkedItems"
                  :value="selectall[0].value" />&nbsp;&nbsp;{{ selectall[0].label }}
                <div style="
                    padding-top: 10px;
                    margin-bottom: 5px;
                    width: 80%;
                    border-bottom: 1px solid lightgray;
                  "></div>
                <div>
                  <div style="line-height: 0.7cm" v-for="(file, index) in facilitytypes" :key="index">
                    <input type="checkbox" class="rounded-checkbox" id="checkbox" v-model="checkedItems"
                      :value="facilitytypes[index].value" />&nbsp;&nbsp;{{ facilitytypes[index].label }}
                  </div>
                  <div v-if="checkedItems.includes(14)">
                    <div style="padding-right: 30px">
                      <input type="text" v-model="specifies" :class="{ 'custom-input': true }" />
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button wide type="danger" @click.native="prevTab" class="btn-previous">
            BACK
          </base-button>
          <base-button v-if="positionid != 4 && step < 5" type="primary" wide @click.native="nextTab" class="btn-next">
            NEXT
          </base-button>
          <base-button v-if="positionid == 4 || step == 5" type="primary" wide @click.native="nextgo()"
            class="btn-next">
            NEXT
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import swal from "sweetalert2";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import moment from "moment";
// import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  props: ["parentData"],
  components: {
    StatusModal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    Circle8,
    // BCard,
    Modal,
  },
  props: ["test1"],
  data() {
    return {
      qtymsg: "",
      modal: modal,
      modals: {
        successModal: false,
        removeModal: false,
      },
      message: "",
      pics: [
        {
          fullsideimages: [],
          insideimages: [],
          landarmrolls: [],
          preoperation: [],
          duringoperation: [],
          postoperation: [],
          flag: "tutup",
          date: "",
          timein: "",
          timeout: "",
          netweight: "",
          quantity: "",
          tyretype: "",
          weightreceipt: [],
          ekafimages: [],
          gatepassimages: [],
          tyretypes: [],
        },
      ],
      tyretypes: [
        {
          type: "",
          qty: 0,
        },
      ],
      disablebtn: true,
      allfilePTWname: [],
      jobno: "",
      servicelocation: "",
      arrivalETA: "18 Nov 2022",
      departureETD: "15 Nov 2022",
      previousPort: "None",
      nextPort: "None",
      lastPortAndDate: "None",
      companyName: "Ombak Biru Holdings",
      companyAddress: "Coplace 2, Switzeeerrrrrss",
      phoneNoFaxNo: "08-98989989",
      picFullName: "Wahab bin Wahab",
      picPhoneNoFaxNo: "012-3569488",
      picEmail: "wahab@sendirianberhad.com",
      shipName: "Tiger Wave",
      imoNo: "8804275",
      shipType: "Ikan bilis tanker",
      grossTonnage: "220000",
      deadweightTonnage: "10000",
      owneroperatorname: "Abu bin Seman",
      callSign: "Bilis dot com",
      flagState: "Malaysia",
      sustainableCertificates: "1 - ISO 14001.pdf",
      shipdoc: [],

      wastedetails: [
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
        {
          no: "1.",
          wastetype: "Annex I - Oil Mixture Sub-waste Type",
          wasteqty: "300 M3",
          maxdedicatedstoragecapacity: "500 M3",
          wasteamountretainedonboard: "50 M3",
          remarks: "None",
        },
      ],

      generate: true,
      selectedFileNamePTW: "",
      allfilenamePTW: [],
      docsPTW: "",
      documentPTW: 0,
      documentIDPTW: [],
      uploadloadPTW: false,

      scroll: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      checkedItems: [],

      selectall: [{ value: 0, label: "Select all" }],

      facilitytypes: [
        { value: 1, label: "Terminal approval" },
        { value: 2, label: "Safety helmet" },
        { value: 3, label: "Life jacket" },
        { value: 4, label: "Hand glove" },
        { value: 5, label: "Safety shoes" },
        { value: 6, label: "Safety vase" },
        { value: 7, label: "Fire extinguisher" },
        { value: 8, label: "Oil boom" },
        { value: 9, label: "Signage" },
        { value: 10, label: "Lorry choke" },
        { value: 11, label: "Oil dip tray" },
        { value: 12, label: "Bariccade" },
        { value: 13, label: "SOPEP equipment" },
        { value: 14, label: "Other (specify):" },
      ],

      specifies: "",

      ptwno: "12089",
      transporter: "Transporter A",
      deliveryterm: "",
      paymentterm: "",
      phoneno: "+60345625454",

      selects: {
        date: "",

        transporter: "",
        transporters: [
          { value: "1", label: "Ikhlas Waste Sdn Bhd" },
          { value: "2", label: "Berjaya Waste Sdn Bhd" },
          { value: "3", label: "Gemilang Waste Holdings" },
        ],
      },
      landvesselflag: "",
      positionid: "",
    };
  },
  created() {
    this.jobno = this.$route.params.jobnum.split("_")[0];
    this.getDetail();
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
  },
  mounted() { },
  methods: {
    openclose(index) {
      if (this.pics[index].flag == "tutup") {
        this.pics[index].flag = "buka"
      } else {
        this.pics[index].flag = "tutup"
      }


      sessionStorage.setItem("tyre" + index, this.pics[index].flag)
    },
    calculateTyreTypeSums() {
      let trips = this.pics;
      let tyreTypeSums = {};

      // Initialize sums to 0 for all tyre types
      this.tyretypes.forEach((tyre) => {
        tyreTypeSums[tyre.type] = 0;
      });

      // Iterate through each trip
      trips.forEach((trip) => {
        this.qtymsg = ""
        trip.tyretypes.forEach((tyre) => {

          if (tyreTypeSums.hasOwnProperty(tyre.type)) {
            // Add to the sum for this tyre type
            tyreTypeSums[tyre.type] += parseInt(tyre.qty);

            // check immediately if exceed max and prompt message
            console.log(tyreTypeSums[tyre.type])
            if (tyreTypeSums[tyre.type] > tyre.maxqty) {
              this.qtymsg =
                "The total for " +
                tyre.type +
                " cannot exceed " +
                tyre.maxqty +
                ". Please adjust the value.";
            }
            // console.log(tyre.maxqty)
            console.log(tyre.qtymsg)
            // console.log(trip)
          }
        });
      });

      console.log(tyreTypeSums)
      let newarray = [];
      for (var key in tyreTypeSums) {
        let oo = {
          type: key,
          sum: tyreTypeSums[key],
        };

        newarray.push(oo);
      }

      // console.log(newarray);
      //
      // newarray.push(tyreTypeSums)
      // console.log(newarray)

      // return tyreTypeSums;
    },
    // validateinput(data, index) {
    //   this.pics.forEach((trip) => {
    //     trip.tyretypes.forEach((tyre) => {
    //       // find tyreTypes
    //       const tyreType = this.tyretypes.find(
    //         (tyretype) => tyretype.wasteid === tyre.wasteid
    //       );

    //       if (!tyreType) {
    //         return;
    //       }
    //       tyreType.sum += parseInt(tyre.qty);

    //        console.log("sum: ", tyreType.sum)
    //        console.log("max qty : ", tyreType.maxqty)
    //       if (tyreType.sum > tyreType.maxqty) {
    //         console.log("sum inside: ", tyreType.sum)
    //         tyre.error = true;

    //         return;
    //       }
    //     });
    //   });
    //   // };
    //   // this.qtymsg = ""
    //   // let sum = 0;
    //   // for (var i = 0; i < this.pics.length; i++) {
    //   //   for (var j = 0; j < this.pics[i].tyretypes.length; j++) {
    //   //     for (var k = 0; k < this.tyretypes.length; k++) {
    //   //       if (
    //   //         this.pics[i].tyretypes[j].wasteid == this.tyretypes[k].wasteid
    //   //       ) {
    //   //         this.pics[i].tyretypes[j].sum += parseInt(this.pics[i].tyretypes[j].qty);
    //   //       }

    //   //       this.pics[i].tyretypes[j].sum = sum;
    //   //     }

    //   //     console.log(this.pics[i].tyretypes[j].sum)

    //   //     if (
    //   //       this.pics[this.pics.length - 1].tyretypes[j].sum >
    //   //       this.pics[i].tyretypes[j].maxqty
    //   //     ) {
    //   //       console.log("masuk sini");
    //   //       this.qtymsg = "Quantity for tyre type " +
    //   //         this.pics[i].tyretypes[j].type +
    //   //         " cannot exceed " +
    //   //         this.pics[i].tyretypes[j].maxqty;

    //   //       // this.pics[i].tyretypes[j].qtymsg =
    //   //       //   "Quantity for tyre type " +
    //   //       //   this.pics[i].tyretypes[j].type +
    //   //       //   " cannot exceed " +
    //   //       //   this.pics[i].tyretypes[j].maxqty;
    //   //     }
    //   //     // else {
    //   //     //   this.qtymsg = ""
    //   //     //   // this.pics[i].tyretypes[j].qtymsg = "";
    //   //     // }
    //   //   }
    //   // }
    //   // console.log(this.pics);

    //   // for (var i = 0; i < this.tyretypes.length; i++) {
    //   //   if (data.wasteid == this.tyretypes[i].wasteid) {
    //   //     this.tyretypes[i].sum += parseInt(data.qty);
    //   //   }

    //   //   if (this.tyretypes[i].sum > this.tyretypes[i].maxqty) {
    //   //     data.qtymsg =
    //   //       "Max quantity cannot exceed " +
    //   //       this.tyretypes[i].maxqty +
    //   //       " for all trip";
    //   //   }
    //   // }

    //   // console.log(this.tyretypes);
    //   // console.log(data);
    //   // console.log(index);
    // },
    deletegatepassimage(index, imageid) {
      console.log(index);
      console.log(imageid);

      this.$http
        .delete(
          ":10001/api/v1/incoming/tyre/" +
          this.jobno +
          "/trip/dashboard/gatepass/" +
          index +
          "/" +
          imageid
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.removeModal = true;

            this.getDetail();
          }
        });
    },
    ongatepasschange(e, index) {
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("images", o);
      }

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }
      this.$http
        .post(
          ":10001/api/v1/incoming/tyre/" +
          this.jobno +
          "/trip/dashboard/gatepass/" +
          index,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            this.getDetail();

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });
      //   }
    },
    deleteekafimage(index, imageid) {
      console.log(index);
      console.log(imageid);

      this.$http
        .delete(
          ":10001/api/v1/incoming/tyre/" +
          this.jobno +
          "/trip/dashboard/ekaf/" +
          index +
          "/" +
          imageid
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.removeModal = true;

            this.getDetail();
          }
        });
    },
    onekafchange(e, index) {
      const t = e.target;
      const formData = new FormData();
      // console.log(t.files[0]);

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("images", o);
      }

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }
      this.$http
        .post(
          ":10001/api/v1/incoming/tyre/" +
          this.jobno +
          "/trip/dashboard/ekaf/" +
          index,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            this.getDetail();

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });
      //   }
    },
    removetrip(index) {
      console.log(index);
      this.pics.splice(index, 1);
    },
    deletearmrollimage(index, imageid) {
      console.log(imageid);

      this.$http
        .delete(
          ":10001/api/v1/incoming/tyre/" +
          this.jobno +
          "/trip/dashboard/load/" +
          index +
          "/" +
          imageid
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.removeModal = true;

            this.getDetail();
          }
        });
    },
    deleteinsideimage(index, imageid) {
      this.$http
        .delete(
          ":10001/api/v1/incoming/tyre/" +
          this.jobno +
          "/trip/dashboard/inside/" +
          index +
          "/" +
          imageid
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.removeModal = true;

            this.getDetail();
          }
        });
    },
    deletefullsideimage(index, imageid) {
      this.$http
        .delete(
          ":10001/api/v1/incoming/tyre/" +
          this.jobno +
          "/trip/dashboard/full-side/" +
          index +
          "/" +
          imageid
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.removeModal = true;

            this.getDetail();
          }
        });
    },
    addtrip() {
      this.pics.push({
        fullsideimages: [],
        flag: "tutup",
        date: "",
        timein: "",
        timeout: "",
        netweight: "",
        quantity: "",
        tyretype: "",
        weightreceipt: [],
        ekafimages: [],
        gatepassimages: [],
        tyretypes: this.tyretypes,
      });
    },
    onprechange(e, index) {
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("images", o);
      }

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/incoming/tyre/" +
          this.jobno +
          "/trip/dashboard/full-side/" +
          index,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            this.getDetail();

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });
      //   }
    },
    onpostchange(e, index) {
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("images", o);
      }

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }
      this.$http
        .post(
          ":10001/api/v1/incoming/tyre/" +
          this.jobno +
          "/trip/dashboard/load/" +
          index,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            this.getDetail();

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });
    },
    onduringchange(e, index) {
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("images", o);
      }

      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }
      this.$http
        .post(
          ":10001/api/v1/incoming/tyre/" +
          this.jobno +
          "/trip/dashboard/inside/" +
          index,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
            this.getDetail();

            // swal({
            //   title: `Success!`,
            //   text: response,
            //   buttonsStyling: false,
            //   confirmButtonClass: "btn btn-primary btn-fill",
            //   type: "success",
            // });
            // this.getDetail();
          }
        });

      //   }
    },
    getDetail() {
      this.allfilePTWname = [];
      this.fullsideimages = [];
      this.pics = [];
      this.shipdoc = [];

      this.$http
        .get(":10001/api/v1/incoming/tyre/" + this.jobno)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            if (typeof response.dashboard_step == 'string') {
              this.step = Number(response.dashboard_step)
            } else if (typeof response.dashboard_step == 'number') {
              this.step = response.dashboard_step;
            } else {
              this.step = response.dashboard_step;
            }
            this.servicelocation = response.service_location.service_location;

            this.companyName = response.company.company_name;
            this.companyAddress = response.company.company_address;

            this.phoneNoFaxNo =
              (response.company.company_phone_number == "" ||
                response.company.company_phone_number == null
                ? "N/A"
                : response.company.company_phone_number) +
              " / " +
              (response.company.company_fax_number == "" ||
                response.company.company_fax_number == null
                ? "N/A"
                : response.company.company_fax_number);
            this.picFullName = response.pic.pic_name;
            this.picPhoneNoFaxNo =
              (response.pic.pic_phone_number == "" ||
                response.pic.pic_phone_number == null
                ? "N/A"
                : response.pic.pic_phone_number) +
              " / " +
              (response.pic.pic_fax_number == "" ||
                response.pic.pic_fax_number == null
                ? "N/A"
                : response.pic.pic_fax_number);

            this.picEmail = response.pic.pic_email;

            // get all ptw
            if (response.ptw_document != null) {
              // for (var i = 0; i < response.ptw_document.length; i++) {
              let obj = {
                filename: response.ptw_document.meta.filename,
                fileurl: response.ptw_document.url,
                fileid: response.ptw_document.ptw_document_id,
              };
              this.allfilePTWname.push(obj);
              // }
            }

            //   if (response.ship.documents != null) {
            //   for (var i = 0; i < response.ship.documents.length; i++) {
            //     let obj = {
            //       filename: response.ship.documents[i].meta.filename,
            //       fileid: response.ship.documents[i].ship_document_id,
            //       fileurl: response.ship.documents[i].url,
            //     };
            //     this.shipdoc.push(obj);
            //   }
            // }

            // get full side image
            if (response.trip != null) {
              for (var i = 0; i < response.trip.length; i++) {
                let preoperation = [];
                let duringoperation = [];
                let postoperation = [];
                for (
                  var j = 0;
                  j < response.trip[i].full_side_image.length;
                  j++
                ) {
                  let obj = {
                    url: response.trip[i].full_side_image[j].url,
                    imageid: response.trip[i].full_side_image[j].image_id,
                    imageindex: response.trip[i].trip_index,
                  };
                  preoperation.push(obj);
                }

                for (var j = 0; j < response.trip[i].inside_image.length; j++) {
                  let obj = {
                    url: response.trip[i].inside_image[j].url,
                    imageid: response.trip[i].inside_image[j].image_id,
                    imageindex: response.trip[i].trip_index,
                  };
                  duringoperation.push(obj);
                }

                for (var j = 0; j < response.trip[i].load_image.length; j++) {
                  let obj = {
                    url: response.trip[i].load_image[j].url,
                    imageid: response.trip[i].load_image[j].image_id,
                    imageindex: response.trip[i].trip_index,
                  };
                  postoperation.push(obj);
                }

                let ekaf = [];
                let gatepass = [];
                let weightreceipt = [];
                if (response.trip[i].ekaf_image.length > 0) {
                  for (var j = 0; j < response.trip[i].ekaf_image.length; j++) {
                    let obj = {
                      url: response.trip[i].ekaf_image[j].url,
                      imageid: response.trip[i].ekaf_image[j].image_id,
                      imageindex: response.trip[i].trip_index,
                    };
                    ekaf.push(obj);
                  }
                }

                if (response.trip[i].gate_pass_image.length > 0) {
                  for (
                    var j = 0;
                    j < response.trip[i].gate_pass_image.length;
                    j++
                  ) {
                    let obj = {
                      url: response.trip[i].gate_pass_image[j].url,
                      imageid: response.trip[i].gate_pass_image[j].image_id,
                      imageindex: response.trip[i].trip_index,
                    };
                    gatepass.push(obj);
                  }
                } else {
                  // gatepass.push({ url: null });
                }
                console.log(gatepass);

                // get weight receipt
                if (response.trip[i].weight_receipt_image != null) {
                  this.isgatepassrequired = true;

                  for (
                    var j = 0;
                    j < response.trip[i].weight_receipt_image.length;
                    j++
                  ) {
                    let obj = {
                      url: response.trip[i].weight_receipt_image[j].url,
                      imageid:
                        response.trip[i].weight_receipt_image[j].image_id,
                      imageindex: response.trip[i].trip_index,
                    };

                    weightreceipt.push(obj);
                  }
                }
                let tyretypes = [];
                // for (var j = 0; j < response.trip[i].net.length; j++) {
                //   let obj = {
                //     wasteid: response.trip[i].net[j].waste_detail_id,
                //     type: response.trip[i].net[j].waste_sub_type_name,
                //     maxqty: response.trip[i].net[j].max_amount,
                //     qty: response.trip[i].net[j].amount,
                //     qtymsg: "",
                //     sum: 0,
                //   };
                //   tyretypes.push(obj);
                // }

                for (var j = 0; j < response.waste_details.length; j++) {
                  let obj = {
                    wasteid: response.waste_details[j].waste_detail_id,
                    type: response.waste_details[j].waste_sub_type_name,
                    maxqty: response.waste_details[j].estimated_quantity,
                    qty: response.waste_details[j].amount,
                    qtymsg: "",
                    sum: 0,
                  };
                  tyretypes.push(obj);
                }

                let payload = {
                  fullsideimages: preoperation,
                  insideimages: duringoperation,
                  landarmrolls: postoperation,
                  style:
                    "box-shadow: 0px 0px;border: none;padding-bottom: none;",
                  flag: sessionStorage.getItem("tyre" + i) == undefined ? "tutup" : sessionStorage.getItem("tyre" + i).toString(),

                  date:
                    response.trip[i].date == ""
                      ? moment()
                      : moment(response.trip[i].date, "YYYY-MM-DD"),
                  timein: moment(response.trip[i].in_time, "HH:mm"),
                  timeout: moment(response.trip[i].out_time, "HH:mm"),
                  netweight: 0,
                  ekafimages: ekaf,
                  gatepassimages: gatepass,
                  weightreceipt: weightreceipt,
                  quantity: response.trip[i].quantity,
                  tyretypes: tyretypes,
                };
                this.pics.push(payload);
              }
            }

            // get tyre types max qty for checking later
            this.tyretypes = [];
            for (var i = 0; i < response.waste_details.length; i++) {
              let obj = {
                wasteid: response.waste_details[i].waste_detail_id,
                type: response.waste_details[i].waste_sub_type_name,
                maxqty: response.waste_details[i].estimated_quantity,
                qty: 0,
                sum: 0,
              };
              this.tyretypes.push(obj);
            }

            console.log(this.tyretypes);
          }
        });
    },
    nextTab() {
      console.log(this.pics);
      let arr = [];
      for (var i = 0; i < this.pics.length; i++) {
        let tyretypeforeachtrip = []
        for (var j = 0; j < this.pics[i].tyretypes.length; j++) {
          console.log(this.pics[i].tyretypes[j])
          let typetypesum = {
            waste_detail_id: this.pics[i].tyretypes[j].wasteid,
            net_amount: parseInt(this.pics[i].tyretypes[j].qty),
            unit: "unit",
          }

          tyretypeforeachtrip.push(typetypesum)

        }

        let obj = {
          reference_number: this.jobno,
          trip_index: i,
          date: moment(this.pics[i].date).format("YYYY-MM-DD"), //2023-01-25
          waste: tyretypeforeachtrip

        }

        arr.push(obj);


        // let obj = {
        //   reference_number: this.jobno,
        //   trip_index: i,
        //   waste: [
        //     {
        //       waste_detail_id: 782,
        //       net_amount: this.pics[i].netweight,
        //       unit: "unit",
        //     },
        //   ],
        //   date: moment(this.pics[i].date).format("YYYY-MM-DD"), //2023-01-25
        // };

        // arr.push(obj);
      }

      console.log(arr)
      this.$http
        .post(
          ":10001/api/v1/incoming/tyre/" + this.jobno + "/update-trips/tyre",
          arr
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            this.modal.success = response;
            this.modals.successModal = true;
            this.nextgo();
            this.warningmsg = "";
          }
        })
        .catch((err) => {
          this.warningmsg = err.response.data.message;
          console.log(err.response.data.message);
        });
    },
    nextgo() {
      let parameter = {
        step: "3",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    prevTab() {
      let parameter = {
        step: "3",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    onFileChangePTW(event) {
      console.log("___________ hoy_________________");
      if (this.allfilePTWname.length == 0) {
        this.docsPTW = this.$refs.ptwfile.files[0];

        this.selectedFileNamePTW = this.$refs.ptwfile.files[0].name;
        this.allfilenamePTW.push(this.selectedFileNamePTW);

        const formData = new FormData();
        formData.append("document", this.docsPTW);

        // to verify form data
        for (var pair of formData.entries()) {
          console.log(pair);
        }

        this.uploadloadPTW = true;

        this.$http
          .post(
            ":10001/api/v1/incoming/scrap/" + this.jobno + "/ptw",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              swal({
                title: `Success!`,
                text: response,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-primary btn-fill",
                type: "success",
              });
              this.getDetail();
              this.uploadloadPTW = false;
            }
          });
      } else {
        swal({
          title: `Info!`,
          text: "Only 1 file allowed to be uploaded",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "info",
        });
      }
    },
    removeFile(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this action!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(":10001/api/v1/incoming/scrap/" + this.jobno + "/ptw")
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                swal({
                  title: `Success!`,
                  text: response,
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-primary btn-fill",
                  type: "success",
                });
                this.getDetail();
              }
            });
        }
      });
    },
    getScroll() {
      this.scroll = true;
    },
    getScroll2() {
      this.scroll = false;
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
    },
  },
  watch: {
    allfilePTWname: {
      handler: function (val, oldVal) {
        if (this.allfilePTWname.length != 0) {
          this.disablebtn = false;
        } else {
          this.disablebtn = true;
        }
      },
      deep: true,
    },
    // pics: {
    //   handler: function (val, oldVal) {
    //     val.forEach((trip) => {
    //       trip.tyretypes.forEach((tyre) => {
    //         // find tyreTypes
    //         const tyreType = this.tyretypes.find(
    //           (tyretype) => tyretype.wasteid === tyre.wasteid
    //         );

    //         if (!tyreType) {
    //           return;
    //         }
    //         tyreType.sum += parseInt(tyre.qty);

    //         if (tyreType.sum > tyreType.maxqty) {
    //           console.log("sum for " + tyreType.type + ": " + tyreType.sum);
    //           tyre.error = true;
    //           return;
    //         }
    //       });
    //     });
    //   },
    //   deep: true,
    // },
    // }),
    // pics: {
    //   // pics = trip
    //   handler: function (val, oldVal) {
    //     console.log("tyretypes: ", this.tyretypes);
    //     const maxQtyArr = this.tyretypes.filter(
    //       (wasteDetail) => wasteDetail.wasteid === 76
    //     );
    //     if (maxQtyArr.length === 0 || maxQtyArr.length > 1) {
    //       console.log("arr length: ", maxQtyArr.length);
    //       return;
    //     }
    //     const maxQty = maxQtyArr[0].maxqty;
    //     console.log("mm: ", maxQty);

    //     let maxTyre = [];
    //     val.forEach((pics) => {
    //       pics.tyretypes.forEach((tyreType) => {
    //         if (maxTyre.length === 0) {
    //           maxTyre.push({ wasteid: tyreType.wasteid, max: tyreType.maxqty });
    //         } else {
    //           const exists = maxTyre.find(
    //             (tyre) => tyre.wasteid === tyreType.wasteid
    //           );
    //           if (exists === -1) {
    //             maxTyre.push(...maxTyre, {
    //               wasteid: tyreType.wasteid,
    //               max: tyreType.maxqty,
    //             });
    //           }
    //         }

    //         console.log("max tyre: ", maxTyre);

    //         console.log("t: ", tyreType);
    //       });
    //       console.log("pics: ", pics);
    //     });
    //     // console.log("value baru:", val)
    //     // console.log("value lama:",oldVal)
    //     // console.log("array:",this.pics)
    //     // this.pics.forEach(function (element) {
    //     //   console.log(element.tyretypes);
    //     //   let newa = element.tyretypes;

    //     //   // if id sama, sum
    //     //   let output = {};
    //     //   newa.forEach(
    //     //     (e) => {
    //     //       for (var i = 0; i < this.tyretypes.length; i++) {
    //     //         if (e.wasteid == this.tyretypes[i].wasteid) {
    //     //           console.log("id sameh");
    //     //         }
    //     //       }
    //     //     }

    //     //   );
    //     //   console.log(output);
    //     //   // });
    //     // });
    //   },
    //   deep: true,
    // },
  },
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-title {
  text-decoration: underline;
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.scrollable {
  height: 500px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}

.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-titles {
  margin-top: -5px;
  color: #A5A5A5;
}

/* Styles for individual buttons */
.left-button,
.right-button {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #358CCB;
  /* You can change the color as desired */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
}

.scrollable-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-bottom: 15px;
  /* Adjust as needed */
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}
</style>
